import { inject, injectable } from 'inversify'
import * as Api from '@xlearn/common';
import { PlayerModule } from '../api'
import { QuestionBankService2, QuestionServiceSymbol } from './service'
import { replaceBasePathInContent } from '../shared/utils/base-path';

@injectable()
export class QuestionPlayerModule implements PlayerModule {

  readonly name = 'question'
  
  constructor(
    @inject(QuestionServiceSymbol)
    private questionService: QuestionBankService2) {}

  start(instance: Api.SerializedAspectInstance): void {
    this.questionService.start(this.resolveQuestionSource(instance));
  }

  reset(instance: Api.SerializedAspectInstance): void {
    this.questionService.reset(this.resolveQuestionSource(instance));
  }

  private resolveQuestionSource(instance: Api.SerializedAspectInstance) {
    const uri = replaceBasePathInContent(instance.basePath)(instance.details.files.questionBankUri);
    return { uri: uri, basePath: instance.basePath }
  }

  async stop() {
    await this.questionService.finish()
  }

}
